import React, { useState } from "react";
import { AddModal, Dropdown } from "components";

// Компонент створення нової категорії ловушки сторінки "Товари постачальників"
const TrapCategoryForm = ({
  isOpen,
  onClose,
  allCategories,
  crmCategories,
  onCreate,
  disabled,
}) => {
  // Локальні стани для керування даними форми
  const [name, setName] = useState("");
  const [parentId, setParentId] = useState(null);
  const [crmCategoryId, setCrmCategoryId] = useState(null);

  // Очищення форми та закриття модального вікна
  const handleClose = () => {
    setName("");
    setParentId(null);
    setCrmCategoryId(null);
    onClose();
  };

  // Функція обробки відправлення форми
  const handleSubmit = (e) => {
    e.preventDefault();

    // Перевіряємо наявність назви категорії
    if (!name.trim()) return;

    // Створюємо нову категорію через пропс onCreate
    onCreate({
      name: name.trim(),
      parent_id: parentId,
      crm_category_id: crmCategoryId,
    });
    handleClose();
  };

  return (
    <AddModal isOpen={isOpen} onClose={handleClose} title="Нова категорія">
      <form onSubmit={handleSubmit}>
        <div className="add-modal-body">
          <div className="form-group">
            <label>Назва категорії *</label>
            <input
              type="text"
              placeholder="Введіть назву"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Батьківська категорія</label>
            <Dropdown
              options={allCategories}
              selected={parentId}
              onChange={setParentId}
              mode="autocomplete"
              placeholder="Оберіть категорію (необов'язково)"
            />
          </div>

          <div className="form-group">
            <label>Категорія CRM *</label>
            <Dropdown
              options={crmCategories}
              selected={crmCategoryId}
              onChange={setCrmCategoryId}
              mode="autocomplete"
              placeholder="Оберіть категорію CRM"
            />
          </div>
        </div>

        <div className="add-modal-footer">
          <button type="button" className="btn-cancel" onClick={handleClose}>
            Відміна
          </button>
          <button type="submit" className="btn-save" disabled={disabled}>
            Додати
          </button>
        </div>
      </form>
    </AddModal>
  );
};

export default TrapCategoryForm;
